<template>
    <v-select
            @change="change($event)"
            @input="input($event)"
            :value="value"
            label="Revision"
            item-value="revision"
            item-text="revision"
            :items="revisiones">
        <template slot="item" slot-scope="data">
            <v-list-tile-content>
                <v-list-tile-title>{{ data.item.revision}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{ data.item.dt_datetime }}
                </v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-select>
</template>

<script>
    import mixinPresup from '../mixins/presupuestoItems'

    export default {
        name: "Revisiones",
        mixins: [mixinPresup],
        props: ['id', 'value'],
        data() {
            return {
                revisiones: [],
            }
        },
        watch: {
            id(value) {
                this.presupuestoItemRevisionList({id: value}, r => {
                    this.$emit('input', r[0].revision);
                    this.revisiones = r;
                }, err => {
                    console.log(err);
                })
            }
        },
        methods: {
            input(e) {
                this.$emit('input', e);
            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Revisiones.vue